/**
 * Checks if a string is null, undefined, or contains only whitespace characters.
 * @param value - The string to check.
 * @returns `true` if the value is null, undefined, or only whitespace; otherwise `false`.
 */
export function isBlank(value: string | null | undefined): boolean {
  return value == null || value.trim().length === 0;
}
